import React from 'react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="border-y border-ink-line bg-ink-soft px-5 py-20 md:py-28" aria-labelledby="temoignages-title" data-id="element-196" data-mp="3kr5uq9dydbmc">
      <div className="mx-auto max-w-6xl" data-id="element-197" data-mp="3fxb4en3udyea">
        <h2 id="temoignages-title" className="font-display text-4xl uppercase leading-none text-cream md:text-6xl" data-id="element-198" data-mp="3b1chl3y5wofz">
          Ce qu’en disent <span className="text-gold" data-id="element-199" data-mp="370aicn48wce0">les professeurs</span>
        </h2>
        <div className="mt-14 grid gap-12 lg:grid-cols-[1.4fr_1fr]" data-id="element-200" data-mp="31yuw4rqbzzu1">
          <figure data-id="element-201" data-mp="2x0jl4doavja8">
            <blockquote className="font-serif text-2xl italic leading-relaxed text-cream md:text-3xl" data-id="element-202" data-mp="2x007381rtf1h">
              « {featured.quote} »
            </blockquote>
            <figcaption className="mt-6 text-sm" data-id="element-203" data-mp="v9gb9qm8i8qq">
              <span className="font-semibold text-gold" data-id="element-204" data-mp="v859fwccnb29">{featured.name}</span>
              <span className="text-cream-muted" data-id="element-205" data-mp="qa3p7836t5p7"> — {featured.role}</span>
            </figcaption>
          </figure>
          <div className="space-y-8 border-ink-line lg:border-l lg:pl-12" data-id="element-206" data-mp="h4wysdjfawnh">
            {rest.map(t => <figure key={t.name} data-id="element-207" data-mp="m5t1ins1gcrb">
                <blockquote className="leading-relaxed text-cream/85" data-id="element-208" data-mp="m2oor20ic8p1">« {t.quote} »</blockquote>
                <figcaption className="mt-3 text-sm" data-id="element-209" data-mp="7a4zn5a701ql">
                  <span className="font-semibold text-gold" data-id="element-210" data-mp="c7mx9zireuja">{t.name}</span>
                  <span className="text-cream-muted" data-id="element-211" data-mp="zvwgctol946q"> — {t.role}</span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}